export const emailValidation = [
    (input) => input.trim().length < 5 ? 'Your email should be at least 5 letters' : null,
    (input) => input.trim().length > 30 ? 'Your email should not be more than 30 letters' : null,
    (input) => /^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/.test(input) ? null : 'Enter a valid email',
]